var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"card__icon"},[_c('img',{attrs:{"src":_vm.props.icon}})])}
var staticRenderFns = []

export { render, staticRenderFns }